import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { IPaginate } from '@projects/shared/src/app/modules/pagination/paginate.pipe';
import { SummariesService } from '../summaries.service';
import { momentCustomInstance as moment, CheckPermission, sortList } from '@projects/shared/src/app/utils/helper';
import { ExportData } from '@projects/shared/src/app/modules/predictive-search-filter/predictive-search-filter.component';
import { naturalSensitiveSort } from '@projects/shared/src/app/utils/sort';
import { AuthenticationService } from '@app/core';
import { DateOptions } from '@projects/shared/src/app/modules/cx-datagrid/cx-datagrid-config';
import { GridMode } from '@projects/shared/src/app/modules/cx-datagrid/types/gridmode';
import { DailySummaryData, contactColumns } from './list.meta';
import { ActivatedRoute } from '@angular/router';
import { AppConfigurationService } from '@projects/shared/src/app/services/app.configuration.service';
import { Subscription } from 'rxjs';
import { ExportService } from '@projects/shared/src/app/services/export.service';
import { formatDate } from '@projects/shared/src/app/utils';
import { NavService } from '@projects/shared/src/app/services/nav.service';
const ColumnKeys = {
  SalesReport: 'sales_report_columns',
  DailySummary: 'daily_summary_columns',
  AgentWise: 'agent_wise_summary_columns',
  AgentActivity: 'agent_activity_summary_columns',
  CallDetails: 'calldetails_summary_columns',
  AgentDisposition: 'agent_disposition_summary_columns',
  SkillWiseSummary: 'skill_wise_summary_columns',
  TFNWiseSummary: 'tfn_wise_summary_columns',
};

const ReportType: any = {
  'sales-report': 'SalesReport',
  'daily-summary': 'DailySummary',
  'agent-wise-summary': 'AgentWiseDaily',
  'agents-acitvity': 'AgentActivity',
  'call-details': 'CallDetails',
  'agent-wise-dispositions': 'AgentDisposition',
  'skill-wise-dispositions': 'skill-wise-summary',
  'tfn-wise-summary': 'TFNWiseSummary',
  'skill-wise-summary': 'SkillWiseSummary',
};

@Component({
  selector: 'app-summaries-repreportsort',
  templateUrl: './summaries-reports.component.html',
  styles: [`
         .alert {
      color: red;
      margin-bottom: 1rem;
    }
    .alert strong {
      margin-right: 4px;
    }
    .column-sorted {
      background-color: #eef2fb; 
    }

      `]
})
export class SummariesReportComponent implements OnInit, OnDestroy {
  @Output() applyDate = new EventEmitter();
  checkPermission = CheckPermission;
  views: any[] = [{ name: 'All', id: '', showPined: false, pined: true }];
  module = 'summaries-';
  fieldmodule = 'summaries';
  GridMode = GridMode;
  gridMode: GridMode = GridMode.Grid;
  totalCount = 0;
  public pagingConfig: IPaginate = {
    id: 'contact-list',
    itemsPerPage: 15,
    currentPage: 1,
    totalItems: this.totalCount,
  }; 
  searchQuery = '';
  datagridPlaceholder = '';
  columns: any[] = [];
  configColumns: any[] = [];
  agentList = [];
  records: any[] = [];
  initialTotalCallListRows = 0;
  toDate: string = moment().endOf('day').toISOString();
  fromDate: string = moment().startOf('day').toISOString(); 
  selectedAgentId: string = '';
  localSearchValue = '';
  pageNumberBeforeLocalSearch = 1;
  export: ExportData = { Data: this.records, FileName: '', Columns: [] };
  filter: any = { fields: '', fieldValues: '', criteria: '', limit: 15, skip: 0 };
  adv_filters: any[] = [];
  call_sid: any = '';
  search_meta: any = [];
  subscriptions: Array<Subscription> = new Array<Subscription>();
  sortColumn: any = { searchField: 'CreatedOn', order: -1 };
  title = '';
  reportType = '';
  show = true;
  moreOptions = {
    label: '',
    directComponentRender: false,
    showFrozenOption: true,
    saveConfig: true,
  };
  constructor(
    public appConfig: AppConfigurationService,
    public service: SummariesService,
    public authService: AuthenticationService,
    public exportService: ExportService,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private navService: NavService
  ) {
    this.subscriptions.push(
      this.route.data.subscribe((x) => {
        this.adv_filters = [];
        this.search_meta = [];
        this.views = [];
        this.columns = [];
        this.datagridPlaceholder = '';
        this.fieldmodule = 'summaries';
        this.filter = { fields: '', fieldValues: '', criteria: '', limit: 15, skip: 0 };
        this.fromDate = moment().startOf('day').toISOString();
        this.totalCount = 0;
        this.pagingConfig = {
          id: 'contact-list',
          itemsPerPage: 15,
          currentPage: 1,
          totalItems: this.totalCount,
        };

        this.show = false;
        if (route.snapshot.routeConfig?.path === 'agent-wise-summary') {
          this.fieldmodule = 'agents-summary';
        } else if (route.snapshot.routeConfig?.path === 'daily-summary') {
          this.fieldmodule = 'daily-summary';
        } else if (route.snapshot.routeConfig?.path === 'agents-acitvity') {
          this.fieldmodule = 'agents';
        }

        this.module = 'summaries-' + (route.snapshot.routeConfig?.path || '');
        this.title = x.title;
        this.init();

        // this.cd.detectChanges();
      }));
    this.subscriptions.push(
      this.navService.onCenterChangeEvent$.subscribe(() => {
        this.getList();
      })
    );
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  // mapDateColumn() {
  //   this.columns = this.columns.filter(Boolean).map((x) => {
  //     if (x.key === 'start_end') {
  //       x.options = DateOptions;
  //     }
  //     return x;
  //   });
  //   this.datagridPlaceholder =
  //     'Search by ' +
  //     this.columns
  //       .filter((x) => x.searchable)
  //       .map((x) => x.name)
  //       .join(', ');
  // }

  mapDateColumn() {
    const filteredDateOptions = DateOptions.filter(opt => opt.value !== 'All');

    this.columns = this.columns.filter(Boolean).map((x) => {
      if (x.key === 'start_end') {
        x.options = filteredDateOptions;
      }
      return x;
    });

    this.datagridPlaceholder =
      'Search by ' +
      this.columns
        .filter((x) => x.searchable)
        .map((x) => x.name)
        .join(', ');
   this.configColumns = JSON.parse(JSON.stringify(this.columns));     
  }

  reset() {
    this.records = [];
    this.pagingConfig.totalItems = 0;
    this.pagingConfig.itemsPerPage = 15;
    this.pagingConfig.currentPage = 1;    
    this.toDate = moment().endOf('day').toISOString();
    this.fromDate = moment().startOf('day').toISOString(); 
  }

  init() {
    this.reset();
    const path: string = this.route.snapshot.routeConfig?.path || '';
    this.reportType = ReportType[path] || 'None';
    if (path === 'call-details') {
      this.export.FileName = 'call_details_report';
      this.columns = this.appConfig.getByIdentifier(ColumnKeys.CallDetails).Fields.columns;
    } else if (path === 'daily-summary') {
      this.export.FileName = 'daily_summary_report';
      this.columns = this.appConfig.getByIdentifier(ColumnKeys.DailySummary).Fields.columns;
    } else if (path == 'agents-acitvity') {
      this.export.FileName = 'agents_activity_report';
      this.columns = this.appConfig.getByIdentifier(ColumnKeys.AgentActivity).Fields.columns;
    } else if (path == 'agent-wise-dispositions') {
      this.export.FileName = 'agent_dispositions_report';
      this.columns = this.appConfig.getByIdentifier(ColumnKeys.AgentDisposition).Fields.columns;
    } else if (path == 'tfn-wise-summary') {
      this.export.FileName = 'tfn_summary_report';
      this.columns = this.appConfig.getByIdentifier(ColumnKeys.TFNWiseSummary).Fields.columns;
    } else if (path == 'skill-wise-summary') {
      this.export.FileName = 'skill_summary_report';
      this.columns = this.appConfig.getByIdentifier(ColumnKeys.SkillWiseSummary).Fields.columns;
    } else if (path == 'agent-wise-summary') {
      this.export.FileName = 'agent_summary_report';
      this.columns = this.appConfig.getByIdentifier(ColumnKeys.AgentWise).Fields.columns;
    } else if (path == 'sales-report') {
      this.export.FileName = 'sales_report';
      this.columns = this.appConfig.getByIdentifier(ColumnKeys.SalesReport).Fields.columns;
    }
    const defaultSort = this.columns.find(c => c.defaultSortField);
    this.sortColumn = {
        searchField: defaultSort?.defaultSortField ?? 'CreatedOn',
        order: defaultSort?.defaultSortOrder ?? -1
    };
    console.log('columns', this.columns);
    console.log('path', path);
    this.mapDateColumn();
    this.getGridSetting();
    setTimeout(() => {
      this.show = true;
      this.cd.detectChanges();
    }, 0);
    this.getList();
  }

  ngOnInit(): void {
    this.init();
  }

  onApplyDate(values: any) {
    this.fromDate = moment(values[0]).startOf('day').toISOString();
    this.toDate = moment(values[1]).endOf('day').toISOString();
    //reset pagination
    this.pagingConfig.currentPage = 1;
    this.filter.skip = 0;
    //fetch data
    this.getList();
  }

  exportData(event: any) {
    this.getListSubscription().subscribe((data: any) => {
      this.export.Data = data.Results || [];
      this.export.Data = this.formatData(this.export.Data);
      this.export.Columns = this.columns.filter((d: any) => d.viewable !== false && d.name).map((d: any) => d.key);
      if (this.export.Columns?.length)
        event.exportCallback(this.export.Data, this.export.FileName, this.export.Columns, this.columns);
    });
  }

  exportAllData(event: any) {
    this.getListSubscription({ IsExportAll: true }).subscribe((data: any) => {
      this.export.Data = data.Results || [];
      this.export.Data = this.formatData(this.export.Data);
      this.export.Columns = this.columns.filter((d: any) => d.viewable !== false && d.name).map((d: any) => d.key);
      if (this.export.Columns?.length)
        event.exportCallback(this.export.Data, this.export.FileName, this.export.Columns, this.columns);
    });
  }

  formatData(data: any) {
    let _data = data.map((row: any) => {
      return Object.entries(row).reduce((dataObj: any, [prop, value]) => {
        const col = this.columns.find((col) => col.key === prop);
        if (col?.format === 'date') dataObj[prop] = moment(value).format('DD MMM YYYY');
        else if (col?.format === 'time') dataObj[prop] = formatDate(Number(value));
        else dataObj[prop] = value;
        return dataObj;
      }, {});
    });

    return _data.map((row: any) =>
      this.columns.reduce((rowObject: any, column: any) => {
        if (!row.hasOwnProperty(column.key) && column.viewable && column.name) row[column.key] = 'NA';
        return row;
      }, {})
    );
  }

  onExport($event: any) {
    if ($event.limit === 'all-data') {
      $event.exportCallback = this.exportService.exportToCsvV2.bind(this.exportService);
      this.exportAllData($event);
    } else {
      $event.exportCallback = this.exportService.exportToCsvV2.bind(this.exportService);
      this.exportData($event);
    }
  }

  getListSubscription(additionalOptions = {}) {
    const payload = {
      Type: this.reportType,
      Sightline: {
        StartDate: this.fromDate,
        EndDate: this.toDate,
        Fields: this.filter.fields,
        FieldValues: this.filter.fieldValues,
        Criteria: this.filter.criteria,
        Limit: this.filter.limit,
        Skip: this.filter.skip,
        AdvFilters: this.adv_filters,
        SearchMeta: this.search_meta,
        SortMeta: {
          order: this.sortColumn.order == 1 ? this.sortColumn.order : -1,
          field: this.sortColumn.searchField,
        },
        ...additionalOptions,
      },
    };
    return this.service.getSummaryReportByType(payload);
  }

  getList = (): void => {
    this.getListSubscription().subscribe((data: any) => {
      this.records = data.Results || [];
      this.totalCount = data.TotalCount;
      this.pagingConfig.totalItems = this.initialTotalCallListRows = data.TotalCount;
    });
  };

  onSort(e: any) {
    this.totalCount = 0;
    this.pagingConfig = {
      id: 'contact-list',
      itemsPerPage: this.pagingConfig.itemsPerPage,
      currentPage: 1,
      totalItems: this.totalCount,
    };
    this.filter = { fields: '', fieldValues: '', criteria: '', limit: this.pagingConfig.itemsPerPage, skip: 0 };
    const { key, name, display, order } = e;
    this.columns.forEach((col: any) => {
      if (col.key !== key) {
        col.order = false;
      }
    });
    this.sortColumn = e;
    this.getList();
  }

  onPageChange(page: number) {
    this.pagingConfig.currentPage = this.pageNumberBeforeLocalSearch = page;
    this.filter = {
      ...this.filter,
      limit: this.pagingConfig.itemsPerPage,
      skip: (this.pagingConfig.currentPage - 1) * this.pagingConfig.itemsPerPage,
    };
    if (!this.localSearchValue) {
      this.getList();
    } else {
      this.pagingConfig.totalItems = this.records.length;
    }
  }

  onPageSizeChange(pageSize: any) {
    this.pagingConfig.itemsPerPage = pageSize;
    this.pagingConfig.currentPage = 1;
    this.filter = {
      ...this.filter,
      skip: 0,
      limit: this.pagingConfig.itemsPerPage,
    };
    if (!this.localSearchValue) {
      this.getList();
    } else {
      this.pagingConfig.totalItems = this.records.length;
    }
  }

  onSearch(value: string) {
    this.getList();
  }

  onCreateView(view: any) {
    const views = this.views;
    view.cid = 'cid-' + new Date().getTime();
    this.views.push(view);
    localStorage.setItem('views', JSON.stringify(views));
  }

  onViewsChange(views: any[]) {
    this.views = views;
    localStorage.setItem('views', JSON.stringify(views));
  }

  onFilter($event: { searchMeta: Array<any>; filters: Array<any>; adv_filters: Array<any>; is_refresh: boolean }) {
    if (!$event.is_refresh) {
      this.pagingConfig.currentPage = 1;
      this.pagingConfig.totalItems = 0;
      this.filter.skip = 0;
    }

    $event.filters.forEach((filter: any) => {
      if (filter.key === 'agent') {
        this.selectedAgentId = filter.value || '';
      } else if (filter.key === 'start_end') {
        this.fromDate = moment(filter.value[0]).toISOString();
        this.toDate = moment(filter.value[1]).toISOString();
      } else if (filter.key === 'call_sid') {
        this.call_sid = filter.value || '';
      }
    });
    this.adv_filters = $event.adv_filters;
    this.search_meta = $event.searchMeta;
    this.getList();
  }

  // need to be create a pipe
  formatDateLocal(num: number) {
    return formatDate(num);
  }

  public onGridSettingSave($event: any): void {
    this.navService.setGridSettings(`grid_${this.reportType}`, $event);
  }
  public getGridSetting(): void {
    this.navService.getGridSettings(`grid_${this.reportType}`).subscribe((gridSettings: any) => {
      if (gridSettings.length > 0) {
       const orderedColumns = gridSettings
          .map((setting: any) => {
            const column = this.columns.find(
              (col) => col.key === setting.key
            );
            if (column) {
              return {
                ...column, 
                frozen: setting.frozen,
                viewable: setting.viewable,
              };
            }

            return null;
          })
          .filter(Boolean);
          this.columns = orderedColumns;
        const startEndColumn = this.configColumns.find(col => col?.key === 'start_end');
        const filteredDateOptions = DateOptions.filter(opt => opt.value !== 'All');
        if (startEndColumn) {
          startEndColumn.options = filteredDateOptions;

          if (!this.columns.some(col => col?.key === 'start_end')) {
            this.columns.push(startEndColumn);
          }
        }
      }
    });
  }
}
